/**
 * Reads the question an ask tool put to the user from that tool call's persisted arguments. Every
 * ask tool names it `prompt`. Returns null when the call carried no usable prompt, which only
 * happens for a malformed call the backend would have rejected anyway.
 */
export const readWorkspaceAgentAskQuestion = (argumentsBag: Record<string, unknown>): string | null => {
  const prompt = argumentsBag.prompt;

  if (typeof prompt !== 'string') {
    return null;
  }

  const trimmed = prompt.trim();

  return trimmed.length > 0 ? trimmed : null;
};
